export { storage as storageHelper } from './storage'

// 默认缓存期限为7天
export const DEFAULT_CACHE_TIME = 60 * 60 * 24 * 7
